/** REQ-059 D2 — identificador humano de tarea (BM-0001). Presentación mínima, accesible y copiable. */
export function TaskCode({ code }: { code?: string | null }) {
  if (!code) return null;
  return <span data-testid="task-code" title="Código de tarea" className="mr-1.5 inline-block select-all rounded bg-surface-variant px-1.5 py-0.5 align-middle font-mono text-[10px] font-semibold text-on-surface-variant">{code}</span>;
}
export default TaskCode;
